import { Field, Radio, RadioGroup } from "@fluentui/react-components";
import { TodayFilterOptions } from "../../../../enum/global-filter/GlobalFilterEnum";

interface ITodayFilterProps {
  selectedOption: string;
  setTodayOption: (option: string) => void;
}

const TodayFilter: React.FC<ITodayFilterProps> = ({
  selectedOption,
  setTodayOption,
}) => {
  const todayOptions = TodayFilterOptions.map((option) => (
    <Radio key={option.id} value={option.id} label={option.label} />
  ));

  return (
    <Field className="pa-sm-2 fw-500">
      <RadioGroup
        value={selectedOption}
        onChange={(_ev, data) => setTodayOption(data.value)}
      >
        {todayOptions}
      </RadioGroup>
    </Field>
  );
};
export default TodayFilter;
